var render = function render(){var _vm=this,_c=_vm._self._c;return _c('image-field',{staticClass:"cell-icon",attrs:{"src":_vm.srcVal,"max-width":"20","height":"20","contain":""},on:{"onClick":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }